/**
 * Displays stable status values with semantic color treatment.
 */

const ClassByStatus: Readonly<Record<string, string>> = Object.freeze({
  CANCELLED: "bg-slate-100 text-slate-700",
  CLOSED: "bg-slate-100 text-slate-700",
  COMPLETED: "bg-emerald-100 text-emerald-900",
  IN_INVESTIGATION: "bg-purple-100 text-purple-800",
  NOT_COMPLETED: "bg-rose-100 text-rose-900",
  PENDING_ASSIGNMENT: "bg-orange-100 text-orange-900",
  PROGRAMMED: "bg-sky-100 text-sky-900",
  RECEIVED: "bg-cyan-100 text-cyan-900",
  // Response draft statuses shown in the response panel.
  APPROVED: "bg-emerald-100 text-emerald-900",
  PENDING_APPROVAL: "bg-amber-100 text-amber-900",
  REJECTED: "bg-rose-100 text-rose-900",
  WORKING: "bg-indigo-100 text-indigo-900",
});

const FallbackClass = "bg-slate-100 text-slate-700";

interface StatusBadgeProps {
  readonly title: string;
  readonly value: string;
}

/**
 * Renders text in addition to color so status never depends on color alone.
 */
export function StatusBadge({ title, value }: StatusBadgeProps) {
  return (
    <span
      className={`inline-flex rounded-full px-2.5 py-1 text-xs font-semibold ${ClassByStatus[value] ?? FallbackClass}`}
    >
      {title}
    </span>
  );
}
